import React from "react";

export const FeedIcon = () => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="feed-icon"
    >
      <mask id="path-1-inside-1_17601_1578" fill="white">
        <path d="M5 2C5 0.89543 5.89543 0 7 0H13C14.1046 0 15 0.895431 15 2V8C15 9.10457 14.1046 10 13 10H7C5.89543 10 5 9.10457 5 8V2Z" />
      </mask>
      <path
        d="M5 2C5 0.343146 6.34315 -1 8 -1H12C13.6569 -1 15 0.343146 15 2C15 1.44772 14.1046 1 13 1H7C5.89543 1 5 1.44772 5 2ZM15 10H5H15ZM5 10V0V10ZM15 0V10V0Z"
        fill="white"
        mask="url(#path-1-inside-1_17601_1578)"
      />
      <mask id="path-3-inside-2_17601_1578" fill="white">
        <path d="M2.99951 4.4165C2.99951 3.31193 3.89494 2.4165 4.99951 2.4165H14.9995C16.1041 2.4165 16.9995 3.31193 16.9995 4.4165V10.4165C16.9995 11.5211 16.1041 12.4165 14.9995 12.4165H4.99951C3.89494 12.4165 2.99951 11.5211 2.99951 10.4165V4.4165Z" />
      </mask>
      <path
        d="M2.99951 4.4165C2.99951 2.62158 4.45459 1.1665 6.24951 1.1665H13.7495C15.5444 1.1665 16.9995 2.62158 16.9995 4.4165C16.9995 4.00229 16.1041 3.6665 14.9995 3.6665H4.99951C3.89494 3.6665 2.99951 4.00229 2.99951 4.4165ZM16.9995 12.4165H2.99951H16.9995ZM2.99951 12.4165V2.4165V12.4165ZM16.9995 2.4165V12.4165V2.4165Z"
        fill="white"
        mask="url(#path-3-inside-2_17601_1578)"
      />
      <rect
        x="0.75"
        y="5.75"
        width="18.5"
        height="12.5"
        rx="3.25"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  );
};
